import { useParams } from "react-router";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { TreatmentComponent } from "@/services/backend/rlt/treatments/components/treatment-component";
import { Column } from "@/services/backend/rlt/treatments/lib/treatment-component-state";

export function WorkOrderPlanningTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useRltWorkOrderShowQuery({ id: workOrderId! });

  return (
    <TreatmentComponent
      treatmentId={data!.treatmentId}
      defaultColumns={[
        Column.Position,
        Column.ComponentKind,
        Column.ComponentData,
        Column.Cycle,
        Column.CleanTime,
        Column.Comment,
        Column.Actions,
      ]}
    />
  );
}
